import Page from './Page.tsx'
import { Button } from "@mui/material"
import { context } from "../../index.js"
import { observer } from "mobx-react-lite"
import PageFinal from "./PageFinal.tsx"
import PreviousAnswers from './PreviousAnswers.tsx'
import { checkJwtRole } from '../../misc/utils.ts'


export default observer(function Questionnaire () {
    return (
        <div className={context.submitting ? "questionnaire disabled" : "questionnaire"}>
            <QuestionnaireHeader />
            <QuestionnaireBody />
        </div>
    )
})


const QuestionnaireHeader = observer(() => {
    
    const { showPreviousAnswers, showSettings, togglePreviousAnswers, toggleSettings, logout, backPage, pageIndex, getSubmittedPages, getQuestionnaireTitle, embedded, answers, template } = context
    const submittedPages = getSubmittedPages()
    const questionnaireTitle = getQuestionnaireTitle()
        
    return (
        <div style={{display: "grid", gap: "10px"}}>
            <small style={{color: "grey"}}>{questionnaireTitle}</small>

            <div className="questionnaire-header">
                {showPreviousAnswers || showSettings ? (
                    <Button
                        className="btn btn-sm"
                        variant="contained"
                        color="success"
                        onClick={() => {
                            togglePreviousAnswers(false)
                            toggleSettings(false)
                        }}>
                        <b>Back to questionnaire</b>
                    </Button>
                ) : (
                    <>
                        <Button
                            disabled={pageIndex === 0 || submittedPages?.length < 1 || showPreviousAnswers}
                            className="btn btn-sm"
                            variant="contained"
                            onClick={() => backPage()}>
                            <b>Go back</b>
                        </Button>

                        {submittedPages.length ? (
                            <Button
                                className="btn btn-sm"
                                color="secondary"
                                variant="contained"
                                onClick={() => togglePreviousAnswers()}>
                                <b>See previous answers</b>
                            </Button>
                        ) : null}
                        
                        {template.settings ? (
                            <Button
                                disabled={answers["settings_confirmed"] !== "true"}
                                className="btn btn-sm"
                                color="secondary"
                                variant="contained"
                                onClick={() => toggleSettings()}>
                                <b>Settings</b>
                            </Button>
                        ) : null}
                    </>
                )}

                {embedded ? (
                    <Button
                        className="btn btn-sm"
                        // variant="contained"
                        color="secondary"
                        onClick={() => logout()}>
                        Log out
                    </Button>
                ) : null}
            </div>
        </div>
    )
})


const QuestionnaireBody = observer(() => {

    const { submitting, getPage, showPreviousAnswers, questionnaire, showSettings } = context

    const page = getPage()

    if (showPreviousAnswers) {
        return (
            <div>
                <h2 style={{margin: "30px 0 20px 0"}}>Your Answers</h2>
                <p>These are the answers provided by <b>{context.respondentEmail}</b> in response to this '{questionnaire.template.displayName}' questionnaire.</p>
                <PreviousAnswers />
            </div>
        )
    }
    
    if (page) {
        
        // Use show_settings to disable settings, don't hide them completely
        const disabled = (!checkJwtRole("show_settings") && showSettings) || submitting
        
        return (
            <div className={disabled ? "disabled" : ""}>
                <Page page={page} />
            </div>
        )
    }

    return <PageFinal />
})